<template>
  <b-container 
    class="mobile-header p-2 fixed-top d-lg-none">
    <b-row class="align-items-center justify-content-between m-0">
      <b-col
        cols="1"
        class="p-0 mr-3 d-flex align-items-center">
        <router-link
          to="/members"
          class="mobile-header__icon-link">
          <span class="mobile-header__icon mobile-header__icon--list material-icons">
            format_list_bulleted
          </span>
        </router-link>
      </b-col>
      <template v-if="hasSelectedMember">
        <b-col
          cols="auto"
          class="px-0 d-flex justify-content-center profile-button-col">
          <b-button
            v-if="showProfileButton"
            :to="isProfilePage ? `/members/${selectedMember.id}` : `/members/${selectedMember.id}/profile`"
            class="profile-button p-1 text-decoration-none"
            size="sm"
            :variant="isProfilePage ? 'primary' : 'outline-primary'">
            マイデータ
          </b-button>
        </b-col>
        <b-col
          class="px-0 mobile-header__member-col">
          <div class="mobile-header__member d-flex align-items-center justify-content-center">
            <img
              v-if="selectedMember.avatar"
              :src="selectedMember.avatar"
              class="img-fluid mobile-header__img rounded-circle">
            <b-avatar
              v-else
              size="22px"
              :text="selectedMember.name|initial" />
            <h1 class="mobile-header__name text-truncate">
              {{ selectedMember.name }}
            </h1>
          </div>
        </b-col>
        <b-col
          cols="auto"
          class="text-center px-0 mobile-header__group-col">
          <slot />
        </b-col>
        <b-col
          v-if="slotInset"
          class="p-0 mobile-header__spacer-col" />
      </template>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  props: {
    selectedMember: {
      type: Object,
      default: null
    },
    showCompass: {
      type: Boolean,
      default: false
    },
    // true のときスロット（グループ選択ボタンなど）を右端からスペーサー1カラム分左に寄せる
    slotInset: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapGetters('auth', ['isAnyManager']),
    ...mapState('auth', ['user']),
    hasSelectedMember() {
      return this.selectedMember !== null
    },
    isProfilePage() {
      return this.$route.path.split('/')[3] === 'profile'
    },
    isViewingOtherMember() {
      return this.user && this.selectedMember.id !== this.user.id
    },
    showProfileButton() {
      return this.isAnyManager && !this.isViewingOtherMember
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-header {
  max-width: 500px;
  margin: auto;
  padding-right: 15px !important;

  background-color: $white;
  border-bottom: solid 1px $grey11;

  $profile-btn-width: 60px;

  .profile-button-col {
    min-width: $profile-btn-width;
  }

  .profile-button {
    width: $profile-btn-width;
    font-size: 0.625rem;
    line-height: 1.2;
    box-shadow: 1px 2px 6px $grey05;
    white-space: nowrap;
  }

  @media screen and (min-width:768px) {
    width: 100%;
    max-width: 100%;
  }
  &__member-col {
    min-width: 0;
  }

  &__spacer-col {
    // cols="1"（行幅の8.33%）だと768px以上でヘッダーが全幅になった際にスペーサーが肥大化し、
    // メンバー名カラム（マイデータボタンとメンバー画像の間の余白）を圧迫するため上限を設ける
    flex: 0 0 8.3333%;
    max-width: 2.5rem;
  }

  &__icon-link {
    display: flex;
    align-items: center;
    text-decoration: none;
  }

  &__icon{
    &--list{
      color: $grey12;
    }
  }
  &__img,
  &__member > .b-avatar {
    margin-left: 0.25rem;
    margin-right: 0.5rem;
  }
  &__img{
    width: 22px;
    height: 22px;
    object-fit: cover;
  }
  &__member {
    // 中央寄せを保ったまま隣のボタンとの最低限の余白を確保する
    // （名前は text-truncate + min-width: 0 で最後に省略される）
    padding: 0 0.75rem;
  }
  &__name{
    font-size: $fs-nm;
    font-weight: bold;
    min-width: 0;
  }

  ::v-deep .category-list_wrapper {
    right: -29px;
  }
}
</style>